import React from "react";
import { isNull } from "lodash";
import styled from "styled-components";
import { Locale } from "@linkfluence/models/locale";
import Counter from "./counter";
import Evolution from "./evolution";

export interface IProps {
  count: number;
  evolution: number;
  isNarrow?: boolean;
  locale: Locale;
  onClick?: () => void;
  className?: string;
  evolutionTooltip?: React.ReactNode;
  isPercentage: boolean;
  disableAnimation?: boolean;
  isFullscreen?: boolean;
}

const Root = styled.div`
  white-space: nowrap;
`;

const KPI = ({
  count,
  evolution,
  isNarrow,
  locale,
  onClick,
  className,
  evolutionTooltip,
  isPercentage = false,
  disableAnimation,
}: IProps) => {
  return (
    <Root className={className}>
      <Counter
        count={count}
        isNarrow={isNarrow}
        locale={locale}
        onClick={onClick}
        isPercentage={isPercentage}
        disableAnimation={disableAnimation}
      />
      {!isNull(evolution) && (
        <Evolution
          locale={locale}
          evolution={evolution}
          tooltip={evolutionTooltip}
          percentagePoint={isPercentage}
        />
      )}
    </Root>
  );
};

export default KPI;
